const convertDuration = (duration) => {
  if (!isNaN(duration) && Number.isInteger(parseFloat(duration))) {
    const hours = Math.floor(duration / 60);  
    const minutes = duration % 60;
    return hours + ":" + (minutes < 10 ? ("0" + minutes) : minutes) + " h"
  }
}
export default convertDuration